import React from 'react'
import styles from "./css/ProductDetailNavbar.module.css"
import Navbar from '../../Navbar/Navbar'

export default function ProductDetailNavbar() {
  return (
    <div className={styles.productnavbar}>
      <Navbar/>

    </div>
  )
}
